<template>
    <div>
        <v-card>
            <v-card-title>
                <v-text-field
                        v-model="search"
                        append-icon="search"
                        :label='$t("captainCreatePage.search")'
                        single-line
                        hide-details
                        @keyup.enter="getData"
                ></v-text-field>
            </v-card-title>
            <v-data-table :url="url"
                          :headers="headers"
                          :items="data"
                          :pagination.sync="pagination"
                          :total-items="totalItems"
                          :loading="loading"
            >
                <template v-slot:items="props">
                    <td class="text-xs-start">{{ props.item.id }}</td>
                    <td class="text-xs-start">
                        <router-link style="text-decoration: none" :to="'captains/' + props.item.captain_id">{{
                            props.item.captain }}
                        </router-link>
                    </td>
                    <td class="text-xs-start">{{ props.item.brand }}</td>
                    <td class="text-xs-start">{{ props.item.model }}</td>
                    <td class="text-xs-start">{{ props.item.color }}</td>
                    <td class="text-xs-start">{{ props.item.number }}</td>
                    <td class="text-xs-start">{{ moment(props.item.insurance_expired_date).format('DD MMM YYYY') }}</td>
                    <td class="text-xs-start">{{ moment(props.item.car_manufacture_date).format('YYYY') }}</td>
                    <td class="text-xs-start">{{ $companyTime(props.item.created_at, 'hh:mm A, DD MMM YYYY') }}</td>
                    <td>
                        <v-icon @click.close="openDialog('Approve', props.item.id, props.index)">done</v-icon>
                        <v-icon @click="openDialog('Deny', props.item.id, props.index)">close</v-icon>
                    </td>
                </template>
            </v-data-table>
        </v-card>

        <v-dialog v-model="dialog" :max-width="dialog_type === 'Deny' ? 350 : null">
            <v-card>
                <v-card-title class="headline">{{ dialogTitle }}</v-card-title>
                <v-card-text v-if="dialog_type === 'Approve'">
                    <p><b>{{ $t("captainCreatePage.approveHint") }}</b></p>
                    <car-info @next_step="approved" ref="car_info"></car-info>
                </v-card-text>
                <v-card-text v-else>
                    {{ $t("captainCreatePage.denyHint") }}
                    <v-form ref="form" v-model="valid">
                        <v-text-field
                                v-model="deny_reason"
                                :rules="reasonRules"
                                :label='$t("captainCreatePage.denyReason")'
                                required
                        ></v-text-field>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn type="default" flat="flat" @click="dialog = false">{{ $t("captainCreatePage.cancel") }}</v-btn>
                    <v-btn :color="dialog_type === 'Deny' ? 'red' : 'green' + ' darken-1'" flat="flat" @click="process">
                        {{ dialog_type !== 'Deny' ? $t("captainCreatePage.approve") : $t("captainCreatePage.deny") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import DataTable from "@/components/monaco/DataTable";
    import CarInfo from "@/components/confirmation_captain_components/CarInfo";

    export default {
        name: "CarRequests",
        title() {
            return this.$t("captainCreatePage.pageTitleCarRequests");
        },
        components: {CarInfo, DataTable},
        data() {
            return {
                dialog: false,
                dialog_type: '',
                url: 'car',
                deny_reason: '',
                car: {
                    id: null,
                    services: null
                },
                valid: false,
                data: [],
                loading: false,
                search: '',
                loadingService: false,
                searchService: '',
                items: [],
                totalItems: 0,
                pagination: {},
                selected_services: []
            };
        },
        computed: {
            headers() {
                return [
                    {text: this.$t("captainCreatePage.id"), value: 'id'},
                    {text: this.$t("captainCreatePage.captain"), value: 'captain'},
                    {text: this.$t("captainCreatePage.brand"), value: 'brand'},
                    {text: this.$t("captainCreatePage.model"), value: 'model'},
                    {text: this.$t("captainCreatePage.color"), value: 'color'},
                    {text: this.$t("captainCreatePage.number"), value: 'number'},
                    {text: this.$t("captainCreatePage.insuranceExpire"), value: 'insurance_expired_date'},
                    {text: this.$t("captainCreatePage.manuYear"), value: 'car_manufacture_date'},
                    {text: this.$t("captainCreatePage.createdAt"), value: 'created_at'},
                    {text: this.$t("captainCreatePage.actions"), value: 'Actions'},
                ];
            },
            reasonRules() {
                return [
                    v => !!v || this.$t("captainCreatePage.denyReasonRequired")
                ];
            },
            dialogTitle() {
                return this.dialog_type === 'Deny'
                    ? this.$t("captainCreatePage.denyCarTitle")
                    : this.$t("captainCreatePage.approveCarTitle");
            }
        },
        watch: {
            selected_services: {
                handler(val) {
                    this.car.services = JSON.parse(JSON.stringify(val));
                },
                deep: true
            },
            pagination: {
                handler() {
                    this.getData();
                },
                deep: true
            },
            searchService(val) {
                this.loadingService = true;
                this.axios.get(`service?search=${val}`)
                    .then(res => {
                        if (res.data.data.data.length) {
                            this.items = res.data.data.data;
                        }
                    }).catch(err => console.log(err.response)).finally(() => this.loadingService = false)
            }
        },
        mounted() {
            this.getData();
        },
        methods: {
            process() {
                if (this.dialog_type === 'Deny') {
                    if (!this.$refs.form.validate()) {
                        return;
                    }
                    this.axios.put(`car/${this.car.id}`, {
                        approved: false,
                        deny_reason: this.deny_reason
                    }).then(() => this.approved()).catch(err => console.log(err.message));
                } else {
                    this.$refs.car_info.submit();
                }
            },
            approved() {
                this.dialog_type = '';
                this.data.splice(this.car.index, 1);
                this.car = {};
                this.dialog = false;
            },
            openDialog(type, car_id, index) {
                this.dialog_type = type;
                this.dialog = true;
                this.car = {id: car_id, index: index};
                if (this.dialog_type !== 'Deny') {
                    setTimeout(() => {
                        this.$refs.car_info.reset();
                        this.$refs.car_info.update(car_id, true);
                    }, 10);
                }
            },
            getData() {
                this.loading = true;
                const params = new URLSearchParams();
                params.append('page', this.pagination.page);
                params.append("perPage", String(this.pagination.rowsPerPage));
                params.append("sortBy", String(this.pagination.sortBy));
                params.append("descending", String(this.pagination.descending));
                params.append("search", String(this.search));
                this.axios.get(this.url, {params})
                    .then(res => {
                        this.data = res.data.data.data;
                        this.totalItems = res.data.data.total;
                        this.pagination.rowsPerPage = Number(res.data.data.per_page);
                        this.loading = false;
                    }).catch(err => {
                    console.log(err.message);
                    this.loading = false;
                });
            },
        }
    }
</script>

<style scoped>

</style>